import NewGrocComp from './NewGrocComp';
import NewMGrocComp from './NewMGrocComp';
import AboutGROC from './AboutGROC';
import HallOffFame from './HallOffFame';
import MAboutGROC from './MAboutGROC';
import MHallOffFame from './MHallOffFame';

export { NewGrocComp, NewMGrocComp, AboutGROC, HallOffFame, MAboutGROC, MHallOffFame };